import { styled } from '@mui/material';

export const Wrap = styled('div', {
	shouldForwardProp: (prop) => prop !== 'isThematic',
})<{ isThematic?: boolean }>(({ theme, isThematic }) => ({
	borderRadius: '8px',
	paddingInline: '8px',
	maxWidth: '100%',
	height: '32px',
	display: 'flex',
	alignItems: 'center',

	...(isThematic
		? { background: theme.palette.warning.main, color: theme.palette.warning.contrastText }
		: { background: theme.palette.info.main, color: theme.palette.info.contrastText }),

	'& .MuiTypography-root': {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		width: '100%',
	},
}));
